import { render, staticRenderFns } from "./OrdersRevenueByMonthChart.vue?vue&type=template&id=8f14f904&scoped=true&"
import script from "./OrdersRevenueByMonthChart.vue?vue&type=script&lang=js&"
export * from "./OrdersRevenueByMonthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f14f904",
  null
  
)

export default component.exports